import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AccountNegotiationComponent} from "./account-negotiation.component";
import {MatLegacySelectModule} from "@angular/material/legacy-select";
import {MatIconModule} from "@angular/material/icon";
import {FormsModule} from "@angular/forms";
import {MatLegacyTooltipModule} from "@angular/material/legacy-tooltip";
import {SpinnerComponent} from "../../../component/spinner/spinner.component";



@NgModule({
  declarations: [
    AccountNegotiationComponent,
  ],
  imports: [
    CommonModule,
    MatLegacySelectModule,
    MatIconModule,
    FormsModule,
    MatLegacyTooltipModule,
  ],
  exports: [
    AccountNegotiationComponent,
  ]
})
export class AccountNegotiationModule { }
